/** @format */

export const MEDIAPLAN_LOOKBACK_YEARS = -4;
